import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://my-json-server.typicode.com/Code-Pop/Real-World_Vue-3',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

export default {
  getCompanies(){
    return apiClient.get('/events')
  },
  getCompany(id){
    return apiClient.get('/events/'+id)
  }
}